import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useCallback, useState } from "react";
import { useGetAllMeetingsQuery } from "../../../redux/Hire/candidateMeetingApi";
import { CandidateDetails } from "../../../redux/Hire/jobRequestApi";
import { HiringStageCode } from "../../../utils/constants";
import ScheduledCallDialog from "../Compoenents/ScheduleCallDialog";
type Props = {
  candidate?: CandidateDetails;
};

const ScreeningStage = ({ candidate }: Props) => {
  const { data, isFetching } = useGetAllMeetingsQuery({
    candidateId: candidate?.id.toString() || "",
    candidateStage: HiringStageCode.SHORTLIST,
  });
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const handleCloseDialog = useCallback(() => setShowDialog(false), []);
  const handleOpenDialog = useCallback(() => setShowDialog(true), []);
  return (
    <Grid container gap={2} alignItems="center">
      <Grid item>
        {isFetching && <CircularProgress size={20} />}
        {!isFetching && data?.data.length === 0 && (
          <Typography fontSize={"14px"} color={"#0F1829"}>
            Call not yet scheduled
          </Typography>
        )}
        {!isFetching && (data?.data.length || 0) > 0 && (
          <>
            <Typography fontSize={"14px"} color={"#0F1829"}>
              Screening interview scheduled
            </Typography>
            <Typography fontSize={"14px"} color={"#0F1829"} fontWeight={700}>
              {moment(data?.data[0].meetingStartedOn).format(
                "Do MMMM YYYY, hh:mm a",
              )}
            </Typography>
          </>
        )}
      </Grid>
      <Grid item>
        <Dialog open={showDialog} maxWidth="md" fullWidth>
          <DialogContent>
            <ScheduledCallDialog
              candidate={candidate}
              closeBox={handleCloseDialog}
            />
          </DialogContent>
        </Dialog>

        <Button variant="outlined" onClick={handleOpenDialog}>
          {!isFetching && (data?.data.length || 0) > 0
            ? "View Call Details"
            : "Schedule Call"}
        </Button>
      </Grid>
    </Grid>
  );
};

export default ScreeningStage;
